import { styled } from '@mui/material/styles';

export const iconStyle = {
  fontSize: { xs: 16, sm: 20, md: 24 },
  borderRadius: '50%',
  color: 'black',
  background: 'white',
};

export const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
  borderRadius: 8,
});
